import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state

// Define the initial state using that type

const NotificationSlice = createSlice({
  name: "HeaderNotif",

  initialState: { headerNotifData: [] },
  reducers: {
    setheaderNotifData: (state: any, action: PayloadAction<any>) => {
      console.log("ACTION @ EMP notif--", action);
      state.headerNotifData = action.payload;
    },

    resetheaderNotifData: (state: any) => {
      state = [];
    },
  },
});

export const { setheaderNotifData, resetheaderNotifData } =
  NotificationSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default NotificationSlice.reducer;
